import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
    root: {
        margin: "40px 0px",
    },
    title: {
        fontSize: "1.5rem !important",
        fontWeight: "500 !important",
        marginBottom: "20px !important",
        textAlign: "center",
    },
}));

const TransferMoneyBangla = () => {
    const classes = useStyle();
    return (
        <div className={classes.root}>

            <Typography className={classes.title}>
                নিয়ম ও শর্তাবলী <br />
                “এসটি পে থেকে ভিসা ডেবিট কার্ডে ফান্ড ট্রান্সফার”
            </Typography>

            <ol >
                <li>এসটি পে থেকে ভিসা ডেবিট কার্ডে ফান্ড ট্রান্সফার শুরু করার সময় গ্রাহককে অবশ্যই সঠিক ডেবিট কার্ড নম্বর প্রদান করতে হবে। গ্রাহকের ভুল বা অসম্পূর্ণ কার্ড তথ্যের কারণে কোনো লেনদেন ব্যর্থ হওয়া, ভুল গন্তব্যে প্রেরণ বা অর্থের ক্ষতির জন্য এসটি পে কোনোভাবেই দায়ী থাকবে না।</li>

                <li>লেনদেন অনুমোদনের জন্য গ্রাহককে এসটি পে অথেনটিকেশন ক্রেডেনশিয়াল (যেমন পিন, ওটিপি বা বায়োমেট্রিক ভেরিফিকেশন, প্রযোজ্য অনুযায়ী) প্রদান করতে হবে। গ্রাহক নিজেই এসব তথ্যের গোপনীয়তা রক্ষা করার জন্য সম্পূর্ণভাবে দায়ী এবং কোনো তৃতীয় পক্ষের সাথে শেয়ার করা যাবে না।</li>

                <li>একবার এসটি পে থেকে ভিসা ডেবিট কার্ডে লেনদেন সফলভাবে শুরু হলে তা এসটি পে এর মাধ্যমে বাতিল বা রিভার্স করা সম্ভব নয়। তাই ট্রান্সফার নিশ্চিত করার আগে গ্রাহকদের সকল তথ্য সতর্কতার সাথে যাচাই করার পরামর্শ দেওয়া হচ্ছে।</li>

                <li>এসটি পে তৎক্ষণাৎ ফান্ড ক্রেডিট হওয়ার নিশ্চয়তা দেয় না। গন্তব্য ব্যাংক, কার্ড নেটওয়ার্ক বা অন্যান্য মধ্যস্থতাকারী প্রতিষ্ঠানের প্রসেসিং সময়ের কারণে কোনো বিলম্ব হলে তার জন্য এসটি পে দায়ী থাকবে না।</li>

                <li>গ্রাহকের ভুল, নিয়ম না মানা, অপর্যাপ্ত ব্যালেন্স, ভুল তথ্য প্রদান অথবা ইস্যুকারী ব্যাংক, কার্ড নেটওয়ার্ক বা নিয়ন্ত্রক কর্তৃপক্ষের আরোপিত সীমাবদ্ধতার কারণে কোনো লেনদেন প্রত্যাখ্যাত, রিভার্স বা ব্লক হলে এসটি পে দায়ী থাকবে না।</li>

                <li>এসটি পে থেকে ভিসা ডেবিট কার্ডে ফান্ড ট্রান্সফার-এ ফান্ড ট্রান্সফার পরিমাণের উপর ১.৫% চার্জ প্রযোজ্য।</li>

                <li>ভিসা ডেবিট কার্ডে করা ট্রান্সফারের ক্ষেত্রে সফল লেনদেন নিশ্চিত হওয়ার পর স্বল্প সময়ের মধ্যে অর্থ ক্রেডিট হতে পারে। কিছু ক্ষেত্রে সংশ্লিষ্ট ব্যাংক ও কার্ড নেটওয়ার্কের প্রসেসিং সময় অনুযায়ী অর্থ ক্রেডিট হতে সর্বোচ্চ সাত কার্যদিবস পর্যন্ত সময় লাগতে পারে।</li>

                <li>পেন্ডিং লেনদেন, ব্যর্থ ট্রান্সফার বা সেবাসংক্রান্ত যেকোনো প্রশ্নের ক্ষেত্রে গ্রাহককে এসটি পে কাস্টমার সাপোর্টের সাথে যোগাযোগ করতে অনুরোধ করা হচ্ছে। হেল্পলাইন <a href="tel:+8809617343434" style={{ color: "#3d96ff" }}>+8809617343434</a> অথবা ইমেইল <a href="mailto:support@stpay.net" style={{ color: "#3d96ff" }}>support@stpay.net</a> এর মাধ্যমে যোগাযোগ করা যাবে।</li>

                <li>এসটি পে প্রযোজ্য আইন ও নিয়ন্ত্রক বিধিমালা অনুযায়ী যেকোনো সময় পূর্ব ঘোষণা ছাড়াই এসটি পে থেকে ভিসা ডেবিট কার্ড সেবা পরিবর্তন, স্থগিত বা বন্ধ করার এবং এই শর্তাবলী সংশোধনের অধিকার সংরক্ষণ করে।</li>
                <br />
            </ol>


            <style>{`
                ol {
                    margin-left: -10px;
                    text-align: justify;
                }

                ol li::marker {
                    font-weight: 600;
                }

                ol li {
                    padding-left: 15px;
                    margin-bottom: 10px;
                }
            `}</style>

        </div>
    );
};

export default TransferMoneyBangla;